module.exports = __webpack_public_path__ + "static/media/oldtruck.bdda1c17.png";